import { createSlice } from "@reduxjs/toolkit"
import { DEFAULT_SEASON_YEAR_NUMBER } from "utils/seasonYear"

const initialState = {
    pageNumber: 1,
    pageSize: 100,
    type: "",
    leaderName: "",
    location: "",
    startDate: "",
    hierarcyFilter: "",
    endDate: "",
    year: DEFAULT_SEASON_YEAR_NUMBER,
}

const weeklyFilterReducer = createSlice({
    name: "weeklyFilters",
    initialState,
    reducers: {
        setFilters: (state, action) =>  {
            return { ...state, ...action.payload }
        },
        clearFilters: () => initialState,
    },
})

export const {
    setFilters,
    clearFilters,
} = weeklyFilterReducer.actions

export default weeklyFilterReducer.reducer
